export const hasContactField = (fields) => [fields.name, fields.phone, fields.email].some((value) => value !== null && value !== undefined);
//# sourceMappingURL=has-contact-field.js.map